import * as React from "react";
import TextField from "@mui/material/TextField";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { Controller, useFormState } from "react-hook-form";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
/////////////////////////////////////////
export default function MaterialUIPickers({
  name,
  views,
  chnageWatcher = () => {},
  inputFormat,
  sx,
  className,
  label,
  minDate,
  maxDate,
}) {
  const formState = useFormState();

  return (
    <Controller
      name={name}
      render={({ field: { onChange, onBlur, value, ref } }) => (
        <DesktopDatePicker
          label={label}
          inputFormat={inputFormat ? inputFormat : "dd/MM/yyyy"}
          views={views ? [...views] : ["year", "month", "day"]}
          sx={{}}
          onChange={(info) => {
            chnageWatcher(false ,info , name);
            onChange(info);
          }}
          onBlur={onBlur}
          value={value}
          ref={ref}
          helperText={
            (formState.errors && formState.errors[name]?.message) || " "
          }
          renderInput={(params) => (
            <TextField size="small" sx={{ ...sx }} {...params} className={className}/>
          )}
          minDate={minDate}
          maxDate={maxDate}
        />
      )}
    />
  );
}
